import grid from './grid'

const people =
{
    ...grid,
    helmet :
    {
        title : 'Personnes' ,
        metas : []
    },
    empty  : 'Aucune personne trouvée',
    search : 'Rechercher une personne ...' ,
    title  : 'Personnes'
};

export default people ;
